module.exports = __webpack_public_path__ + "static/media/amberWarningIocn.fb58a229.svg";